import {
  FlexRow,
  MaterialIcon,
  StyledButton,
  StyledSearchBar,
  useDebouncedSearch,
  useModal,
} from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { useRecoilState, useResetRecoilState } from 'recoil';
import useEffectOnce from '../../../hooks/useEffectOnce';
import { useStyles } from '../../../hooks/useStyles';
import { webServicesSearchFilterState } from '../../../storage/webServices';
import StyledTooltip from '../../ui/StyledTooltip';
import WebServiceDetailModal from './modal/WebServiceDetailModal';

type Props = {
  subClientId: string;
  onReloadPage: () => void;
};
export function WebServiceFiltersBar({ subClientId, onReloadPage }: Readonly<Props>) {
  const { css, theme } = useStyles();
  const { openModal: openFormModal, closeModal: closeFormModal, showModal: showFormModal } = useModal();
  const { search, setSearch } = useDebouncedSearch(useRecoilState(webServicesSearchFilterState));
  const resetSearch = useResetRecoilState(webServicesSearchFilterState);

  useEffectOnce(() => {
    return () => {
      resetSearch();
    };
  });

  return (
    <FlexRow
      classNames={css({
        justifyContent: 'space-between',
        width: '100%',
      })}
    >
      <FlexRow
        gap={theme.sizing.scale300}
        classNames={css({
          width: '70%',
        })}
      >
        <FlexRow
          classNames={css({
            width: '60%',
          })}
        >
          <StyledSearchBar
            value={search ?? ''}
            onChange={setSearch}
            clearable
            noMargin
          />
        </FlexRow>
      </FlexRow>
      <FlexRow gap={theme.sizing.scale300}>
        <StyledTooltip
          content={'Recargar tabla'}
          showArrow={false}
        >
          <Button
            size="compact"
            shape="square"
            onClick={onReloadPage}
            kind="tertiary"
          >
            <MaterialIcon name={'refresh'} />
          </Button>
        </StyledTooltip>
        <StyledButton
          onClick={openFormModal}
          startEnhancer={
            <MaterialIcon
              name="add"
              size="xs-mini"
              color={theme.colors.contentInversePrimary}
            />
          }
        >
          Nuevo
        </StyledButton>
      </FlexRow>
      {showFormModal && (
        <WebServiceDetailModal
          subClientId={subClientId}
          onClose={(updateTable) => {
            if (updateTable) {
              onReloadPage();
            }
            closeFormModal();
          }}
          isOpen={showFormModal}
        />
      )}
    </FlexRow>
  );
}
